import React from 'react';
import { howItWorks } from '../data/mock';

const HowItWorks = () => {
  return (
    <section className="section-padding bg-gray-950 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 grid-pattern opacity-20" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-500/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="accent-line mx-auto mb-6" />
          <h2 className="section-title text-white mb-4">How It Works</h2>
          <p className="subtitle max-w-2xl mx-auto">
            Booking your photo booth is simple. Here's how to get started.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-4 gap-8">
          {howItWorks.map((step, index) => (
            <div key={step.step} className="relative text-center group">
              {/* Connector Line */}
              {index < howItWorks.length - 1 && (
                <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-gray-800">
                  <div className="absolute inset-0 bg-cyan-500/30 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
                </div>
              )}

              {/* Step Number */}
              <div className="relative z-10 w-16 h-16 mx-auto mb-6 bg-gray-900 border-2 border-gray-700 rounded-full flex items-center justify-center group-hover:border-cyan-500 transition-colors duration-300">
                <span className="text-2xl font-bold text-cyan-400 font-display">
                  {step.step}
                </span>
              </div>

              {/* Content */}
              <h3 className="text-xl font-semibold text-white mb-3 font-display">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
